// extracted by mini-css-extract-plugin
export default {"overlay":"PopUp_overlay__T8dd6","popup":"PopUp_popup__2rAgh","title":"PopUp_title__UBR6I","description":"PopUp_description__ZjA3f","button":"PopUp_button__9aPy3"};